import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import root from './root';

const finalCompose = compose;
// (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose; // eslint-disable-line

export default (initalState, context) =>
  createStore(
    root,
    initalState,
    finalCompose(applyMiddleware(thunk.withExtraArgument(context))),
  );
